import React from "react";

const Intro = () => {
  return (
    <section className="intro-section d-flex align-items-md-center align-items-start">
      <div className="intro-background" />
      <div className="container">
        <div className="intro-content">
          <p className="pt-5 pt-md-0 ps-md-0 ps-4">
            Cuando se trata <br />
            de pensar en el <strong className="highlight-blue">futuro</strong>,<br />
            <strong className="highlight-blue">somos</strong> los <strong className="highlight-blue">primeros</strong>{" "}
            en
            <br />
            <strong className="highlight-green">crear tranquilidad</strong>
          </p>
        </div>
      </div>
    </section>
  );
};

export default Intro;
